import ServiceCRUD from '../../../../services/ServiceNPS';

class TagsService extends ServiceCRUD {
  constructor() {
    super('tags');
  }
}

export default new TagsService();
